// extracted by mini-css-extract-plugin
module.exports = {"hx":"footer_hx_2B9gu","footer":"footer_footer_3oFBI","active":"footer_active_2ZDwU"};